import { formatProperty } from '@/lib/format';
import type { SaleGoodsProperty, SaleOrder } from '@/types/sell';

/** Главный параметр качества оффера в читаемый вид: «Протеин ≥ 12,5 %» (null — нет свойства). */
export function mainQuality(offer: SaleOrder): string | null {
  const property: SaleGoodsProperty | undefined = offer.goodsPropertiesSet?.properties?.[0];
  if (!property) {
    return null;
  }
  return formatProperty(property) || null;
}

/**
 * Окно погрузки «01.07.2026 – 15.07.2026» или «с 01.07.2026», если конец не задан; null — даты не заданы.
 * `from` подписывает открытое окно («с {{date}}»): без предлога голая дата читалась бы как срок.
 */
export function loadingWindow(offer: SaleOrder, from: (date: string) => string): string | null {
  const start = offer.loadingConditions?.startDate;
  const end = offer.loadingConditions?.endDate;
  if (start && end) {
    return `${start} – ${end}`;
  }
  return start ? from(start) : null;
}

/** Только ACTIVE/SUSPENDED показываем в «Продам» (проданное/в сделке уходит в «Сделки»). */
export function isVisibleInSell(offer: SaleOrder): boolean {
  return offer.status === 'ACTIVE' || offer.status === 'SUSPENDED';
}
